<template>
  <div class="work_list_box">
    <helpHeader></helpHeader>
    <div class="work_list_content">
      <div class="content-header">
        <div class="left">工单管理平台</div>
        <div class="right">
          <Button type="primary" to="/work/add">+ 新增工单</Button>
        </div>
        <div class="bottom">
          <DatePicker
            type="daterange"
            v-model="page.date"
            placeholder="选择筛选日期"
            style="width: 300px"
          ></DatePicker>

          <Input
            v-model="page.describe"
            style="width: 380px; margin-left: 10px"
            placeholder="关键字：问题描述\提交账号\联系电话\联系邮箱"
          ></Input>
        </div>
        <div style="margin-top: 10px">
          <Select
            v-model="page.cat"
            style="width: 200px"
            placeholder="问题分类"
          >
            <Option value="0">功能需求</Option>
            <Option value="1">后台使用问题</Option>
            <Option value="2">疑问解答</Option>
            <Option value="3">其它问题</Option>
          </Select>
          <Select
            v-model="page.status"
            style="width: 200px; margin-left: 10px"
            placeholder="状态"
          >
            <Option value="0">待受理</Option>
            <Option value="1">受理中</Option>
            <Option value="2">带店铺反馈</Option>
            <Option value="3">待平台反馈</Option>
            <Option value="4">已关单</Option>
          </Select>
          <Select
            v-model="page.level"
            style="width: 200px; margin-left: 10px"
            placeholder="紧急程度"
          >
            <Option value="0">一般</Option>
            <Option value="1">重要</Option>
          </Select>
        </div>
      </div>
      <div>
        <Button type="primary" icon="ios-search" @click="getData(true)"
          >搜索</Button
        >
        <Button style="margin-left: 10px" @click="Reset()">重置</Button>
      </div>
      <div class="line"></div>
      <div class="bottom_left">
        <p class="tag_p">
          <span
            class="tag"
            @click="selectStatus('')"
            :class="{ active: page.status === '' }"
            >全部</span
          >
          <span
            class="tag"
            @click="selectStatus(0)"
            :class="{ active: page.status === 0 }"
            >待受理</span
          >
          <span
            class="tag"
            @click="selectStatus(1)"
            :class="{ active: page.status === 1 }"
            >受理中</span
          >
          <span
            class="tag"
            @click="selectStatus(2)"
            :class="{ active: page.status === 2 }"
            >待店铺反馈</span
          >
          <span
            class="tag"
            @click="selectStatus(3)"
            :class="{ active: page.status === 3 }"
            >待平台反馈</span
          >
          <span
            class="tag"
            @click="selectStatus(4)"
            :class="{ active: page.status === 4 }"
            >已结单</span
          >
        </p>
      </div>
      <div style="margin-top: 15px">
        <Table :columns="columns" :data="data">
          <template slot-scope="{ row, index }" slot="action">
            <Button type="success" size="small" style="margin-right:5px" @click="details(row)">查看</Button>
            <Button v-if="row.status&&row.status!=4" type="primary" size="small" style="margin-right:5px" @click="details(row)">回复</Button>
            <Button v-if='row.status!=4' type="error" size="small" @click="offClick(row.id)">关单</Button>
          </template>
        </Table>

        <div class="t-right t-top-10">
          <Page
            @on-change="pageChange"
            @on-page-size-change="sizeChange"
            :total="total"
            show-elevator
            show-sizer
            show-total
          />
        </div>
      </div>
    </div>

    <Drawer
      :title="modal.title"
      :closable="false"
      v-model="modal.visible"
      width="1200"
    >
      <div class="work_drawer_details">
        <div class="detail-info">
          <div class="parts-title">基本信息</div>
          <div class="info_box" style="padding-left: 10px">
            <Row>
              <Col span="8"
                ><span class="tit">工单编号：</span><span>{{modal.data.no}}</span></Col
              >
              <Col span="8"
                ><span class="tit">紧急程度：</span><span>{{modal.data.level==0?'一般':'重要'}}</span></Col
              >
              <Col span="8"
                ><span class="tit">处理状态：</span><span>{{status[modal.data.status]}}</span></Col
              >
            </Row>
            <Row style="padding-top: 4px">
              <Col span="8"
                ><span class="tit">提交时间：</span
                ><span>{{$moment(modal.data.create_time)}}</span></Col
              >
              <Col span="8"
                ><span class="tit">工单类型：</span><span>{{type[modal.data.cat]}}</span></Col
              >
              <Col span="8"></Col>
            </Row>
            <span class="btn_off_order" @click="offClick"
              >确认关单</span
            >
          </div>
          <div class="parts-title">沟通记录</div>
          <div class="record_list_box">
            <div class="item-top" :class="{item:index>0,right:item.type==0}" v-for="(item,index) in modal.message" :key='index'>
              <div class="name_box" v-if="item.type==1">
                <img class="head" src="../../assets/images/user_avatar.jpg" />
                <span style="margin-right: 30px">18623405855</span>
                <span>{{$moment(item.create_time)}}</span>
              </div>
              <div class="name_box" v-else>
                <span>{{$moment(item.create_time)}}</span>
                <span style="margin-left: 30px; margin-right: 10px"
                  >{{item.tel}}</span
                >
                <img class="head" src="../../assets/images/user_avatar.jpg" />
              </div>
             <div class="content_box">
                <div class="tit">{{index==0?'问题描述':'回复'}}</div>
                <div class="ds">
                   {{item.describe}}
                </div>
                <div class="tit" style="margin-top: 20px">附件</div>
                <div class="f_item" v-for="(i, k) in item.enclosure" :key="k">
                  <span>{{i.name}}</span>
                  <a class="btn_look" target="_blank" :href="i.url">查看</a>
                </div>
              </div>
            </div>
          </div>
          <div class="parts-title">我要反馈</div>
          <div class="message-box">
            <span style="color: #d40000">*</span>
            <span style="margin: 0 6px">留言</span>
            <span style="color: #999">(必填项)</span>
            <div class="desc_input">
              <Input
                v-model="feedbackData.describe"
                type="textarea"
                :autosize="{ minRows: 5 }"
                placeholder="此处限定5000字符"
              />
            </div>
            <div class="subtitle">上传附件</div>
            <div>
               <div class="up_box">
                <Button icon="md-add"
                  >添加附件</Button
                >
                <input
                  type="file"
                  class="file_input"
                  @change="uploadChangeOrder"
                />
              </div>
              <p
                class="filt-tag"
                v-for="(item, index) in files"
                :key="index"
              >
                <Tag closable @on-close="deleteFiles(index)"> {{ item }}</Tag>
              </p>
              <div class="description">
                可上传<span style="color: #f2935e">5个附件</span
                >每个附件大小不得超过8M。附件支持的格式有：'jpg','jpeg','bmp','png',<br />'gif','txt','rar','zip','doc','docx','ini','conf','eml','xlsx','xls','pdf'
              </div>
              <Button
                class="submit"
                :disabled="feedbackData.describe ? false : true"
                @click="subimtMessage"
                >提交</Button
              >
            </div>
          </div>
        </div>
      </div>
    </Drawer>
    <Modal v-model="modalOff.visible" :title="modalOff.title" width="400">
      <Input
        class="modal-off-input"
        v-model="modalOff.data.reason"
        type="textarea"
        :rows="6"
        placeholder="请描述关单原因"
      >
        <span class="dot" slot="prefix">*</span>
      </Input>
      <div slot="footer">
        <Button @click="modalOff.visible = false">取消</Button>
        <Button type="primary" @click="offWork">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import helpHeader from "@/components/help-header";
import { mapActions,mapGetters} from "vuex";
import { resolve } from "q";
import { uploadOSS } from "@/libs/util";
export default {
  components: {
    helpHeader,
  },
  data() {
    return {
      page: {
        l: 10,
        p: 0,
        status: "",
        date: "",
        level: "",
        cat: "",
        describe:"",
      },
      modal: {
        visible: false,
        title: "工单详情",
        data: {
          id:'',
        },
        message:[],
      },
      modalOff: {
        visible: false,
        title: "关单",
        id:"",
        data: {
          reason: "",
        },
      },
      feedbackData: {
        work_id:'',
        describe: "",
        enclosure: [],
      },
      files:[],
      total: 0,
      type:{
              0: "功能需求",
              1: "后台使用问题",
              2: "疑问解答",
              3: "其它问题"
            },
      status:{
              0: "待受理",
              1: "受理中",
              2: '待店铺反馈',
              3: "待平台反馈",
              4: "已关单",
            },
      data: [],
      columns: [
        {
          key: "no",
          title: "工单编号",
          width: 150,
          render: (h, data) => {
            return h(
              "span",
              {
                props: {
                  placement: "top",
                  content: "点击查看",
                },
                on: {
                  click: () => {
                    this.details(data.row);
                  },
                },
                style: {
                  color: "#2d8cf0",
                  cursor: "pointer",
                },
              },
              data.row.no
            );
          },
        },
        { key: "level", title: "紧急程度", width: 200,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.level==0?'一般':'重要'
            );
          },
        },
        { key: "describe", title: "问题描述", width: 220,tooltip:true },
        { key: "cat", title: "问题分类", width: 150 ,
         render: (h, data) => {
            return h(
              "span",
              {},
              this.type[data.row.cat]
            );
          },},
        { key: "tel", title: "提交账号", width: 150 },
        {
          key: "create_time",
          title: "提交时间",
          width: 150,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { key: "status", title: "状态", width: 120,
         render: (h, data) => {
            return h(
              "span",
              {},
              this.status[data.row.status]
            );
          }},

        { key: "phone", title: "联系电话", width: 150 },
        { key: "email", title: "联系邮箱", width: 160 },
        {
          key: "edit",
          title: "操作",
          slot: "action",
          fixed: "right",
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    let params = this.$GetParams(this.$route.name);
    for (let k in params) {
      if (params[k]) this.page[k] = params[k];
    }
  },
  methods: {
    selectStatus(status) {
      this.page.status = status;
      this.getData();
    },
    details(row){
      this.modal.visible = true;
      this.modal.data = row;
      this.feedbackData.work_id = row.id;
      this.GetWorkMessage({work_id:row.id}).then((res) => {
        res.data.map(item=>{
          if(item.enclosure){
            item.enclosure = JSON.parse(item.enclosure)
          }
        })
        this.modal.message = res.data;
      });
    },

    Reset() {
      this.page = {
        l: 10,
        p: 0,
        status: "",
        describe: "",
        date: "",
        level: "",
        cat: "",
      };
      this.$PushParams(this.$route.name, false);
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    getData(reset = false) {
      if (reset) this.page.p = 0;
      console.log('请求数据', this.page)
      if(this.page.date){
        let date = this.page.date;
        this.page.start = date[0]
        this.page.end = date[1]
      }
      this.GetWorkList(this.page).then((res) => {
        this.data = res.data;
      });
    },
    offClick(id){
      this.modalOff.visible = true;
      if(id){
        this.modalOff.id=id
      }else{
        this.modalOff.id=this.modal.data.id;
      }
    },
    offWork() {
      let data ={
        work_id:this.modalOff.id,
        status:4,
        describe:this.modalOff.data.reason
      }
      this.CreateWorkMessage(data).then((res) => {
        if (res.status === true) {
          this.modalOff.visible = false;
          this.$Message.success(res.msg);
          this.getData();
        }
      });
    },
    deleteFiles(index) {
      this.files.splice(index, 1);
      this.feedbackData.enclosure.splice(index, 1);
    },
    uploadChangeOrder(e) {
      console.log("上传的文件", e);
      let file = e.target.files[0];
      if (file.size > 5242880) {
        this.$Notice.warning({
          title: "上传失败",
          desc: `文件”${file.name}“过大`,
        });
        return false;
      }
      this.$Spin.show();
      let date = this.$moment(new Date(), "YYYY-MM-DD");
      let src = `shop/${this.current_user.shop_id}/work/shop_id-${this.current_user.shop_id}/${date}/files/`;
      uploadOSS(src, file).then((oss) => {
        this.$Spin.hide();
         let url ={
          name:file.name,
          url:oss.url,
        }
        this.feedbackData.enclosure.push(url);
        this.files.push(file.name);
      });
    },
    //反馈信息
    subimtMessage(){
      this.feedbackData.enclosure = JSON.stringify(this.feedbackData.enclosure);
      this.CreateWorkMessage(this.feedbackData).then((res) => {
        if (res.status === true) {
          this.$Message.success(res.msg);
          this.feedbackData.describe = '';
          this.feedbackData.enclosure = [];

          this.GetWorkMessage({work_id:this.feedbackData.work_id}).then((res) => {
            res.data.map(item=>{
              if(item.enclosure){
                item.enclosure = JSON.parse(item.enclosure)
              }
            })
            this.modal.message = res.data;
          });
        }
      });
    },
    ...mapActions(["GetWorkList", "CreateWorkMessage","GetWorkMessage"]),
  },
   computed: mapGetters({ current_user: "current_user" }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
